// == Import npm
import React, { useState } from "react";
import { useSelector } from "react-redux";
import classNames from "classnames";

import { Typography } from "antd";

// == Import SCSS
import "./searchByResident.less";

// == Import assets
import { ReactComponent as Character } from "../../assets/illustrations/character-2.svg";

// == import i18n
import { useTranslation } from "react-i18next";

// == import component
import SearchBar from "../SearchBar/SearchBar";
import Tile from "../../common/Tile/Tile";

const SearchByResident = () => {
  const [t] = useTranslation();

  const [display, setDisplay] = useState(true);

  const { residentList } = useSelector(state => state.visits);

  const type = "resident";
  const searchText = t("SearchByFirstOrLastNameOfTheResident");

  const cssClassDisplay = classNames("searchByResident", {
    "searchByResident--display": !display,
  });

  const closeBubble = () => {
    setDisplay(true);
  };

  return (
    <div className={cssClassDisplay} onClick={closeBubble} style={{ height: window.innerHeight }}>
      <p className="searchByResident__texte">
        <Character className="searchByResident__texte__img" />
        {t("WhoDoYouHaveAnAppointmentWith")} ?
      </p>

      <SearchBar
        searchResult={residentList}
        type={type}
        searchText={searchText}
        setDisplay={setDisplay}
      />

      <section className="searchByResident__section--btn">
        <Tile
          href="/searchByVisitor"
          style={{
            height: "100px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            padding: "20px",
          }}
        >
          <Typography.Text strong>
            {t("TheVisitorDoesNotKnow")} <br /> {t("TheNameOfTheResident")}
          </Typography.Text>
        </Tile>
      </section>
    </div>
  );
};

export default SearchByResident;
